import { render, staticRenderFns } from "./SettingsPriceTemplateForm.vue?vue&type=template&id=9f0c8c76&scoped=true&"
import script from "./SettingsPriceTemplateForm.vue?vue&type=script&lang=ts&"
export * from "./SettingsPriceTemplateForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f0c8c76",
  null
  
)

export default component.exports